import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CLabel,
  CRow,
  CSpinner,
  CInvalidFeedback,
  CSelect,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall, apiCallSPGet } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";
// import usersData from "../users/UsersData";
const AddUser = () => {
  useEffect(() => {
    getDistrictList(true);
    getCircleListDrop(true);
  }, []);
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [emailId, setEmailId] = useState();
  const [mobile, setMobile] = useState();
  const [username, setUserName] = useState();
  const [houseNo, setHouseNo] = useState();
  const [streetName, setStreetName] = useState();
  const [area, setArea] = useState();
  const [city, setCity] = useState();
  const [disctrict, setDistrict] = useState();
  const [state, setState] = useState();
  const [pincode, setPincode] = useState();
  const [contact1, setContact1] = useState();
  const [contact2, setContact2] = useState();
  const [contact3, setContact3] = useState();
  const [contact4, setContact4] = useState();
  const [contact5, setContact5] = useState();
  const [fax, setFax] = useState();
  const [alternateEmail, setAlternateEmail] = useState();
  // eslint-disable-next-line no-unused-vars
  const [roleId, setRoleId] = useState(1);
  const [subRoleId, setSubRoleId] = useState();
  const [circleId, setCircleId] = useState(0);
  const [districtId, setDistrictId] = useState(0);
  const [items, setItems] = useState([]);
  const [itemsCricle, setitemsCricle] = useState([]);
  const [signature, setSignature] = useState("");
  const [isViewOnly, setIsViewOnly] = useState(false);
  const { authenticated } = Auth();
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  const [roleMasterId, setRoleMasterId] = useState();
  const [itemsRoleRight, setitemsRoleRight] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    if (authenticated.role === "CGMF" && authenticated.isViewOnly) {
      setdisabledApproveRej(true);
    } else {
      setdisabledApproveRej(false);
    }
    getRoleMasterListDrop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const postUserData = async (e) => {
    e.preventDefault();
    setloading(true);
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setSubmitted(true);
      setloading(false);
    } else {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      const response = await apiCall(
        "User/add",
        "POST",
        header,
        JSON.stringify({
          emailId: emailId,
          mobile: mobile,
          username: username,
          houseNo: houseNo,
          streetName: streetName,
          area: area,
          city: city,
          disctrict: disctrict,
          state: state,
          pincode: pincode,
          contact1: contact1,
          contact2: contact2,
          contact3: contact3,
          contact4: contact4,
          contact5: contact5,
          fax: fax,
          alternateEmail: alternateEmail,
          roleId: Number(roleId),
          subRoleId: Number(subRoleId),
          circleId: Number(circleId),
          districtId: Number(districtId),
          signature: signature,
          roleMasterId: Number(roleMasterId),
          IsViewOnly: !!isViewOnly,
        })
      );
      const jsonobj = await response.json();
      if (response.status === 200 && jsonobj === -2) {
        alert("user already exists with same email address");
      } else if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
        setuserData(jsonobj);
        history.push(
          authenticated.role === "CGMF" ? "/master/userlist" : "/userlist"
        );
      }
    }
    setloading(false);
  };
  const getDistrictList = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`District_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setItems(distJsonobj);
    }
    setloading(false);
  };
  const getCircleListDrop = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Circle_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setitemsCricle(distJsonobj);
    }
    setloading(false);
  };

  const getRoleMasterListDrop = async () => {
    if (authenticated) {
      setloading(true);

      await apiCallSPGet(`RoleMaster/ActiveList`)
        .then((res) => {
          if (res.success) {
            setitemsRoleRight(res.data);
          }
        })
        .finally(setloading(false));
    }
  };

  function convert2base64(e) {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setSignature(reader.result.toString());
    };

    reader.readAsDataURL(file);
  }

  let cfoDrop = (
    <CCol xl={4} md={6} sm={12} className={"mb-2"}>
      <CLabel>Select Circle : </CLabel>
      <CSelect
        required
        // value={circleId}
        aria-label="Default select example"
        onChange={(e) => setCircleId(e.target.value)}
        invalid={circleId === "" ? true : false}
        id="validationCustom19"
      >
        <option value="">Select Circle</option>
        {itemsCricle.map((item, key) => (
          <option key={key} value={item.circleId}>
            {item.name}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom19">
        Please enter circleId
      </CInvalidFeedback>
    </CCol>
  );

  let dfoDrop = (
    <CCol xl={4} md={6} sm={12} className={"mb-2"}>
      <CLabel>Select District : </CLabel>
      <CSelect
        required
        // value={districtId}
        aria-label="Default select example"
        onChange={(e) => {
          setDistrictId(e.target.value);
        }}
        invalid={districtId === "" ? true : false}
        id="validationCustom20"
      >
        <option value="">Select District Union</option>
        {items.map((item, key) => (
          <option key={key} value={item.districtId}>
            {item.name}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom20">
        Please enter districtId
      </CInvalidFeedback>
    </CCol>
  );
  let cgmfDrop = (
    <CCol xl={4} md={6} sm={12} className={"mb-2"}>
      <CLabel>Role Right : </CLabel>
      <CSelect
        required
        value={roleMasterId === null ? "" : roleMasterId}
        aria-label="Default select example"
        onChange={(e) => {
          setRoleMasterId(e.target.value);
        }}
        invalid={submitted && Number(roleMasterId) === 0}
        id="validationCustom21RoleRight"
      >
        <option value="">Select Role Right </option>
        {itemsRoleRight.map((item, key) => (
          <option key={key} value={item.roleMasterId}>
            {item.roleName}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom21">
        Please Select Role Right
      </CInvalidFeedback>
    </CCol>
  );

  const getDropComponent = (subRoleId) => {
    switch (parseInt(subRoleId)) {
      case 1:
        return cgmfDrop;
      case 2:
        return cfoDrop;
      case 3:
        return dfoDrop;
      default:
        return "";
    }
  };
  return (
    <>
      <CCardHeader className="mb-3">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Add User</h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CForm onSubmit={postUserData} className="was-validation">
        <CRow className="mb-3 ml-1">
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel htmlFor="validationCustom01"> Email Address : </CLabel>
            <CInput
              required
              type="email"
              value={emailId}
              onChange={(e) => {
                setEmailId(e.target.value);
              }}
              id="validationCustom01"
              invalid={emailId === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom01">
              Please enter Email ID
            </CInvalidFeedback>
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel htmlFor="validationCustom02"> Mobile No. : </CLabel>
            <CInput
              required
              type="number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              id="validationCustom02"
              invalid={mobile === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom02">
              Please enter Mobile
            </CInvalidFeedback>
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> User Name : </CLabel>
            <CInput
              required
              type="text"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              id="validationCustom03"
              invalid={username === "" ? true : false}
            />
            <CInvalidFeedback className="validationCustom03">
              Please enter Username
            </CInvalidFeedback>
          </CCol>
          {/* </CRow>
        <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> House No. : </CLabel>
            <CInput
              type="text"
              value={houseNo}
              onChange={(e) => setHouseNo(e.target.value)}
              id="validationCustom04"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Street Name : </CLabel>
            <CInput
              type="text"
              value={streetName}
              onChange={(e) => setStreetName(e.target.value)}
              id="validationCustom05"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Area : </CLabel>
            <CInput
              type="text"
              value={area}
              onChange={(e) => setArea(e.target.value)}
              id="validationCustom06"
            />
          </CCol>
          {/* </CRow>
        <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> City : </CLabel>
            <CInput
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              id="validationCustom07"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Disctrict : </CLabel>
            <CInput
              type="text"
              value={disctrict}
              onChange={(e) => setDistrict(e.target.value)}
              id="validationCustom08"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> State : </CLabel>
            <CInput
              type="text"
              value={state}
              onChange={(e) => setState(e.target.value)}
              id="validationCustom09"
            />
          </CCol>
          {/* </CRow>
        <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Pincode : </CLabel>
            <CInput
              type="text"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              id="validationCustom10"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 1 : </CLabel>
            <CInput
              type="text"
              value={contact1}
              onChange={(e) => setContact1(e.target.value)}
              id="validationCustom11"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 2 : </CLabel>
            <CInput
              type="text"
              value={contact2}
              onChange={(e) => setContact2(e.target.value)}
              id="validationCustom12"
            />
          </CCol>
          {/* </CRow>
        <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 3 : </CLabel>
            <CInput
              type="text"
              value={contact3}
              onChange={(e) => setContact3(e.target.value)}
              id="validationCustom13"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 4 : </CLabel>
            <CInput
              type="text"
              value={contact4}
              onChange={(e) => setContact4(e.target.value)}
              id="validationCustom14"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 5 : </CLabel>
            <CInput
              type="text"
              value={contact5}
              onChange={(e) => setContact5(e.target.value)}
              id="validationCustom15"
            />
          </CCol>
          {/* </CRow>
        <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Fax : </CLabel>
            <CInput
              type="text"
              value={fax}
              onChange={(e) => setFax(e.target.value)}
              id="validationCustom16"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Alternate Email : </CLabel>
            <CInput
              type="text"
              value={alternateEmail}
              onChange={(e) => setAlternateEmail(e.target.value)}
              id="validationCustom17"
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Sub Role : </CLabel>
            <CSelect
              required
              value={subRoleId === null ? " " : subRoleId}
              aria-label="Default select example"
              onChange={(e) => {
                setSubRoleId(e.target.value);
              }}
              invalid={submitted && Number(subRoleId) === 0}
              id="validationCustom18SubRole"
            >
              <option value="">Select Role</option>
              <option value={1}>CGMF</option>
              <option value={2}>CFO</option>
              <option value={3}>DFO</option>
            </CSelect>
            <CInvalidFeedback className="validationCustom18">
              Please enter subRoleId
            </CInvalidFeedback>
          </CCol>
          {roleId === 1 && getDropComponent(subRoleId)}
          {/* </CRow>
        <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Upload Signature: </CLabel>
            <CInput
              id="fileupload"
              type="file"
              onChange={(e) => convert2base64(e)}
            />
          </CCol>
          {/* <CCol xl={4}>
          <CLabel> IsViewOnly: </CLabel>
              <input
                type="checkbox"
                size="sm"
                checked={isViewOnly ? true : false}
                onChange={() => setIsViewOnly(!isViewOnly)}
              />
            </CCol> */}
          {roleId === 1 && (
            <>
              <CCol xl={2} md={6} sm={12} className={"mb-2"}>
                <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                  IsViewOnly:
                </CLabel>
                <input
                  style={{
                    margin: 10,
                  }}
                  id="chkIsViewOnly"
                  placeholder=""
                  type="checkbox"
                  checked={isViewOnly ? true : false}
                  onClick={() => {
                    setIsViewOnly(!isViewOnly);
                  }}
                />
              </CCol>
              <CCol xl={2}></CCol>
            </>
          )}
          {/* </CRow>

        <CRow className="mb-3 ml-5"> */}
        </CRow>
        <CRow className="mb-3 ml-3 mt-3">
          {loading ? (
            <CSpinner className="spinner-grow" color="success" variant="grow" />
          ) : (
            <>
              <CButton
                disabled={disabledApproveRej}
                type="submit"
                color="success"
              >
                Add User
              </CButton>

              <CButton
                color="danger"
                className="ml-2"
                to={
                  authenticated.role === "CGMF"
                    ? "/master/userlist"
                    : "/userlist"
                }
              >
                Cancel
              </CButton>
            </>
          )}
        </CRow>
      </CForm>
    </>
  );
};
export default AddUser;
